// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","792":"main"}[chunkId] + "." + {"96":"81a147e6b2f041206fc8","792":"e8f1527e5f07a36d4717"}[chunkId] + ".css";
};